/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowrefinefewer3Inputs */

const en_aiflowrefinefewer3 = /** @type {(inputs: Aiflowrefinefewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fewer elements`)
};

const de_aiflowrefinefewer3 = /** @type {(inputs: Aiflowrefinefewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger Elemente`)
};

/**
* | output |
* | --- |
* | "Fewer elements" |
*
* @param {Aiflowrefinefewer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowrefinefewer3 = /** @type {((inputs?: Aiflowrefinefewer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowrefinefewer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowrefinefewer3(inputs)
	return de_aiflowrefinefewer3(inputs)
});
export { aiflowrefinefewer3 as "aiFlowRefineFewer" }